window.headerEmail = false;
window.header_custom, window.footer_custom;
window.bgEmaildata = "";
(function($) {
    RVwys.plugin["headerEmail"] = true;

    $(document).bind("editorReady", function() {
        $(".button-save-header-email").click(function() {
            parent.RVwys.saveEmailHeader();
            parent.headerEmail = false;
        });

        $(".rv-theme").click(function() {
            var bgcolor = $(this).css("background-color");
            bgcolor = RVwys.HeaderDesign.rgb2hex(bgcolor);
            $(".emSetcolor").spectrum("set", bgcolor);
            $("#bg-color").val(bgcolor);
            $(".rv-theme").removeClass("rv-theme-active");
            $(this).addClass("rv-theme-active");
            var fb = parent.$("#frameBody").get(0).contentWindow;
            fb.$(".emailBackground").css("background-color", bgcolor);
        });

        $(".emSetcolor").spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: "rgb",
            change: function(color) {
                $(".rv-theme").removeClass("rv-theme-active");
                $("#bg-color").val(color.toHexString());
                var fb = parent.$("#frameBody").get(0).contentWindow;
                fb.$(".emailBackground").css(
                    "background-color",
                    color.toHexString()
                );
            }
        });

        $(".btn-save-emailbg").click(function() {
            var email_style = setBackgroundEmaildata();
            var fb = parent.$("#frameBody").get(0).contentWindow;
            $.ajax({
                type: "POST",
                url: "/admin/email/update/savemail",
                data: {
                    savetype: "emailstyle",
                    email_id: $("#email_id").val(),
                    email_type: $("#isType").val(),
                    styleinline: email_style,
                    header_custom: 1
                },
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                error: function(jqXHR, exception) {
                    //console.log(jqXHR.responseJSON.errors.header_content_edit[0]);
                    console.pop.error({
                        text: jqXHR.responseJSON.message
                    });

                    setTimeout(function() {
                        oThis.afterError();
                    }, 1000);
                },
                success: function(data) {
                    parent.bgEmaildata = email_style;
                    setBackgroundEmail(email_style);
                    console.pop.success({
                        text: "Saved Background Success",
                        delay: 3000
                    });
                }
            });
        });
    });

    $(document).bind("designReady", function(e) {
        if (parent.$("#header_id").val() == 0) {
            RVwys.HeaderDesign.EventBannerEmail();
        }
        parent.$(".bg-padding").keyup(function() {
            if ($(this).val() > 100) {
                $(this).val(100);
            }
        });

        parent.$(".button-cancel-header-email").click(function(e) {
            var UI = parent.UIkit;

            oncancel = function() {
                modal.hide();
            };

            var onInsert = function() {
                //reset header
                $.ajax({
                    type: "POST",
                    url: "/admin/email/update/reset/header",
                    data: {
                        email_id: parent.$("#email_id").val(),
                        email_type: parent.$("#isType").val()
                    },
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    },
                    success: function(data) {
                        parent.$("#header_custom").val("");
                        parent.$("#header_id").val("0");

                        $(".selected_emailheader").replaceWith(data);
                        RVwys.HeaderDesign.EventBannerEmail();
                        RVwys.HeaderDesign.RegisHeader(e);
                        RVwys.Brand.Event(e);
                        RVwys.HeaderDesign.setEmailStyle();

                        parent.$(".wys-rowHeaderEmail").hide();
                        parent.console.pop.success({
                            text: "Reset Success",
                            delay: 5000
                        });
                    }
                });

                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvemail">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang("Reset Header") +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content"><span>' +
                        rvLang("Reset Header to default?") +
                        "</span></div>",
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang("Yes") +
                        "</button>",
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang("No") +
                        "</button></div>",
                    "</div>"
                ].join("")
            );

            modal.element
                .find(".js-modal-confirm-cancel")
                .on("click", function() {
                    oncancel();
                })
                .end()
                .find(".uk-button-success")
                .on("click", function() {
                    onInsert();
                });

            modal.show();
        });

        parent.$(".btn-reset-emailbg").click(function(e) {
            var UI = parent.UIkit;

            oncancel = function() {
                modal.hide();
            };

            var onInsert = function() {
                //reset style
                $.ajax({
                    type: "POST",
                    url: "/admin/email/update/reset/style",
                    data: {
                        email_id: parent.$("#email_id").val(),
                        email_type: parent.$("#isType").val()
                    },
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    },
                    success: function(data) {
                        RVwys.uikit.loadEmailBackgroundDesign();
                        RVwys.HeaderDesign.setEmailStyle();
                        parent.console.pop.success({
                            text: "Reset Success",
                            delay: 5000
                        });
                    }
                });

                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvemail">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang("Reset Background") +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content"><span>' +
                        rvLang("Reset Background to default?") +
                        "</span></div>",
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang("Yes") +
                        "</button>",
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang("No") +
                        "</button></div>",
                    "</div>"
                ].join("")
            );

            modal.element
                .find(".js-modal-confirm-cancel")
                .on("click", function() {
                    oncancel();
                })
                .end()
                .find(".uk-button-success")
                .on("click", function() {
                    onInsert();
                });

            modal.show();
        });
    });

    RVwys.uikit.blockprop.HeaderEmail = function() {
        parent.$(".wys-dynamic,.wys-panel,.wys-rowTwo").hide();
        parent.$(".wys-rowHeaderEmail, .panelHeaderEmail").show();
        RVwys.uikit.loadHeaderDesignEmail();
    };

    RVwys.uikit.loadHeaderDesignEmail = function() {
        var layout = $(".design-block").attr("rv-layout");
        if (layout == "undefined" || layout == undefined) {
            setTimeout(function() {
                RVwys.uikit.loadHeaderDesignEmail();
            }, 500);
        }

        if (parent.$("#headerEmailAlbumUikit icon").length == "0") {
            parent
                .$("#headerEmailAlbumUikit")
                .html('<div class="txtSidebar">Loading...</div>');
            var urlCDN = parent.wex.cdn.cdnHeaderDesignEmail;
            var request = $.ajax({
                method: "POST",
                url: urlCDN,
                dataType: "html"
            });

            request.done(function(data) {
                //		    		alert(data);
                parent.$("#headerEmailAlbumUikit").html("");
                var oRolsHeader = $("<div/>").html(data);
                oRolsHeader.find("icon").each(function() {
                    var headerID = oRolsHeader.find("icon").attr("emailheader");
                    var IconHeader = $(this);
                    parent.$("#headerEmailAlbumUikit").append($(this));
                    var urlCDNbyiTem =
                        parent.wex.cdn.cdnURL +
                        "/service/getdesign.php?name=headerdesign&email=email&item=" +
                        headerID;
                    var requestbyiTem = $.ajax({
                        method: "POST",
                        url: urlCDNbyiTem,
                        dataType: "html"
                    });

                    requestbyiTem.done(function(data) {
                        var oRolsHeaderHtml = $("<div/>").html(data);
                        var GroupSection = $("<div/>").html(
                            oRolsHeaderHtml.find(".selected_emailheader")
                        );
                        IconHeader.find(".hvr-glow").attr(
                            "data",
                            GroupSection.html()
                        );
                    });
                });
                RVwys.HeaderDesign.HeaderPreviewEmail();
            });

            request.fail(function(jqXHR, textStatus) {
                RVwys.uikit.loadHeaderDesignEmail();
            });
        }
    };

    RVwys.HeaderDesign.HeaderPreviewEmail = function() {
        var hrefCssOld = $("#headerCss").attr("href");
        var idCssOld = $("#headerCss")
            .attr("href")
            .match(/\d+/);

        var oldHeader = $("#selected_header").clone();
        var oldEmail = $(oldHeader).find(".selected_emailheader");
        var oldtopmenu = $(oldHeader)
            .find("#selected_topmenu tel")
            .html();
        var logo = $(oldHeader)
            .find("logo")
            .html();

        parent.$("#headerEmailAlbumUikit .hvr-glow").click(function(e) {
            parent.headerEmail = true;
            var oRodata = $(this).attr("data");
            var oThis = $(oRodata);
            window.EmailCssHeaderID = oThis.data("emailheader");
            parent.$("#header_custom").val(1);
            oThis.find("#selected_topmenu tel").html(oldtopmenu);
            oThis.find("logo").html(logo);

            $(".selected_emailheader").replaceWith(oThis);

            $("#headerCss").attr(
                "href",
                parent.wex.cdn.cdnURL +
                    "/service/email_html/header/css/" +
                    window.EmailCssHeaderID +
                    ".css"
            );
            $(".emailBackground").removeAttr("style");

            RVwys.HeaderDesign.RegisHeader(e);
            RVwys.Brand.Event(e);
        });

        parent.$(".button-cancel-header-email").click(function(e) {
            parent.headerEmail = false;
            $("#header_custom").val("");
            $(".selected_emailheader").replaceWith(oldHeader.html());
            $("#headerCss").attr("href", hrefCssOld);
            $(".emailBackground").removeAttr("style");

            $(".selected_emailheader")
                .find(".RVWYSIWYGAREA")
                .removeClass("RVWYSIWYGAREA");

            RVwys.HeaderDesign.RegisHeader(e);
            RVwys.Brand.Event(e);
        });
    };

    RVwys.HeaderDesign.setEmailStyle = function() {
        // getmaster style
        $.ajax({
            type: "POST",
            url: "/admin/email/update/getemailstyle",
            data: {
                email_id: parent.$("#email_id").val(),
                email_type: parent.$("#isType").val()
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
            },
            success: function(data) {
                $(".emailBackground").attr("style", data);
            }
        });
    };

    RVwys.HeaderDesign.EventBannerEmail = function(e) {
        var currentPage = parent.$("#cmsCurrent").text();

        var btnCustom = $(
            '<a class="uk-button uk-button-primary" id="editCustombanner" style="position: absolute;top: 0;right: 0;z-index: 10;"> Custom this banner?</a>'
        );

        if ($("#CustomBannerFigure").length == 0) {
            $("#selected_header").addClass("rv-banner-overlay");
            $(".selected_emailheader").prepend(
                '<figcaption id="CustomBannerFig" class="uk-overlay-panel  rv-overlay-bg">' +
                    '<button class="uk-button uk-button-primary btnCustomEmail uk-float-right" onclick="RVwys.setScollPostionFormDesign("setBanner");">' +
                    '<i class="uk-icon uk-icon-wrench"></i>' +
                    rvLang("Custom this Header?") +
                    "</button>" +
                    '<div id="keyWordCustom" class="uk-float-right custom-banner-content">' +
                    rvLang(
                        "Header Banner in this page is Inherited from home page."
                    ) +
                    "</div></figcaption>"
            );
        }

        $(".btnCustomEmail").click(function() {
            //							setStatus
            parent.$("#header_custom").val("1");
            RVwys.uikit.blockprop.HeaderEmail(this);

            $(".overlayCustomBanner").remove();
            $("#CustomBannerFig").remove();
            $("#selected_header").unbind("mouseenter");
        });

        $(".hideCustombanner").click(function() {
            $("#selected_headerbanner").append(btnCustom);
            // $('#selected_headerbanner').append(overlaypanelCustom);
            $(".overlayCustomBanner").remove();
            $("#CustomBannerFig").remove();
        });

        if ($("#editCustombanner")) {
            $("#editCustombanner, .layCustomBanner").show();
        }

        $("#editCustombanner").click(function() {
            $(".layCustomBanner").remove();
            $("#editCustombanner").remove();
        });

        $("#selected_header")
            .on("mouseenter", function() {
                $("#CustomBannerFig").show();
                $("#selected_header")
                    .addClass("rv-banner-overlay-hover")
                    .removeClass("rv-banner-overlay");
                $("#selected_header").css({
                    position: "relative"
                });
            })
            .mouseleave(function() {
                $("#selected_header")
                    .addClass("rv-banner-overlay")
                    .removeClass("rv-banner-overlay-hover");
            });
    };

    RVwys.HeaderDesign.EventClickDesignEmail = function() {
        if (
            parent.$("#header_id").val() == "0" &&
            parent.$("#header_custom").val() == ""
        ) {
            var UI = parent.UIkit;
            oncancel = function() {
                modal.hide();
            };

            var onInsert = function(e) {
                $(".btnCustomEmail").trigger("click");
                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvemail">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang("Custom Header") +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang(
                            "Header Banner in this page is Inherited from parent page."
                        ) +
                        "</div>",
                    '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang("Custom this Header?") +
                        "</button>",
                    '<button class="uk-button js-modal-confirm-cancel">Cancel</button></div>',
                    "</div>"
                ].join("")
            );
            modal.element
                .find(".js-modal-confirm-cancel")
                .on("click", function() {
                    oncancel();
                })
                .end()
                .find(".uk-button-success")
                .on("click", function() {
                    onInsert();
                });

            modal.show();
        } else {
            RVwys.uikit.blockprop.HeaderEmail();
        }
    };

    RVwys.designViewAddEvent("mousedown", function(e) {
        if (parent.headerEmail) {
            parent.$(".button-save-header-email").trigger("click");
        }
    });

    RVwys.uikit.loadEmailBackgroundDesign = function() {
        var fb = parent.$("#frameBody").get(0).contentWindow;

        var overlaypanel = $('<div class="overlaybgemail"></div>').css({
            "background-color": "red",
            opacity: "0.0",
            position: "absolute",
            left: "0px",
            top: "0px",
            "z-index": "99",
            width: parent.$("body").width(),
            height: parent.$("body").height()
        });
        parent.$("body").append(overlaypanel);

        parent.$(".overlaybgemail").click(function() {
            var current_bgEmail = setBackgroundEmaildata();
            if (current_bgEmail != parent.bgEmaildata) {
                setBackgroundEmail(parent.bgEmaildata);
            }

            parent.$(".wys-EmailBackgroundDesign").hide();
            $(this).remove();
        });

        parent.$(".bg-padding").change(function() {
            var current_bgEmail = setBackgroundEmaildata();
            setBackgroundEmail(current_bgEmail);
        });

        $.ajax({
            type: "POST",
            url: "/admin/email/update/getemailstyle",
            data: {
                email_id: parent.$("#email_id").val(),
                email_type: parent.$("#isType").val()
            },
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
            },
            success: function(data) {
                parent.bgEmaildata = data;
                setBackgroundEmail(data);
            }
        });
    };

    function setBackgroundEmaildata() {
        var email_style = "background:" + parent.$("#bg-color").val() + ";";
        email_style += "padding-top:" + parent.$("#bg-ptop").val() + "%;";
        email_style += "padding-bottom:" + parent.$("#bg-pbottom").val() + "%;";
        email_style += "padding-left:" + parent.$("#bg-pleft").val() + "%;";
        email_style += "padding-right:" + parent.$("#bg-pright").val() + "%;";

        return email_style;
    }

    function setBackgroundEmail(data) {
        var fb = parent.$("#frameBody").get(0).contentWindow;
        fb.$(".emailBackground").attr("style", data);
        data = data.split(";");
        $.each(data, function(i, v) {
            if (~v.indexOf("padding:")) {
                var padding = parseInt(
                    $.trim(v.replace("padding:", "").replace("%", ""))
                );
                parent.$(".bg-padding").val(padding);
            }
            if (~v.indexOf("padding-top:")) {
                var padding = parseInt(
                    $.trim(v.replace("padding-top:", "").replace("%", ""))
                );
                parent.$("#bg-ptop").val(padding);
            }
            if (~v.indexOf("padding-bottom:")) {
                var padding = parseInt(
                    $.trim(v.replace("padding-bottom:", "").replace("%", ""))
                );
                parent.$("#bg-pbottom").val(padding);
            }
            if (~v.indexOf("padding-left:")) {
                var padding = parseInt(
                    $.trim(v.replace("padding-left:", "").replace("%", ""))
                );
                parent.$("#bg-pleft").val(padding);
            }
            if (~v.indexOf("padding-right:")) {
                var padding = parseInt(
                    $.trim(v.replace("padding-right:", "").replace("%", ""))
                );
                parent.$("#bg-pright").val(padding);
            }

            if (~v.indexOf("background:")) {
                parent.$(".rv-theme").removeClass("rv-theme-active");
                var background = $.trim(
                    v.replace("background:", "").replace("%", "")
                );
                parent.$("#bg-color, #apply-bg-color").val(background);

                if (background == "#f2f2f2") {
                    parent.$(".rv-theme-white").addClass("rv-theme-active");
                } else if (background == "#f7e400") {
                    parent.$(".rv-theme-yellow").addClass("rv-theme-active");
                } else if (background == "#e65d17") {
                    parent.$(".rv-theme-orange").addClass("rv-theme-active");
                } else if (background == "#d22b2d") {
                    parent.$(".rv-theme-red").addClass("rv-theme-active");
                } else if (background == "#5dc55f") {
                    parent.$(".rv-theme-green").addClass("rv-theme-active");
                } else if (background == "#09512e") {
                    parent.$(".rv-theme-darkgreen").addClass("rv-theme-active");
                } else if (background == "#0ab8ff") {
                    parent.$(".rv-theme-blue").addClass("rv-theme-active");
                } else if (background == "#104384") {
                    parent.$(".rv-theme-darkblue").addClass("rv-theme-active");
                } else if (background == "#ff5395") {
                    parent.$(".rv-theme-pink").addClass("rv-theme-active");
                } else if (background == "#9878fd") {
                    parent.$(".rv-theme-violet").addClass("rv-theme-active");
                } else if (background == "#682b01") {
                    parent.$(".rv-theme-maroon").addClass("rv-theme-active");
                } else if (background == "#000000") {
                    parent.$(".rv-theme-black").addClass("rv-theme-active");
                }
                parent.$(".emSetcolor").spectrum("set", background);
            }
        });
    }

    RVwys.HeaderDesign.rgb2hex = function(rgb) {
        rgb = rgb.match(
            /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
        );
        return rgb && rgb.length === 4
            ? "#" +
                  ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
                  ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
                  ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2)
            : "";
    };
})(jQuery);
